export default __webpack_public_path__ + "static/media/grilabs-dark.47555d7d.svg";